import * as React from 'react';
import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { Transaction } from 'gossamer-model';

export const TransactionSearch: React.FC = () => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(Transaction);
  const gCacheQueryItem = useCacheQuery(Transaction, queryOptions);
  return (
    <>
      <PageTitle verb="Search" entity={Transaction} />
      <Section>
        <PaginatorAndListSettings
          entity={Transaction}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
